export const MERCHANT_MANAGEMENT = {
    MARKETPLACE_LINK: "merchant-management-marketplace-link",
    CONTACT_INFORMATION: {
        EMAIL: "merchant-management-contact-information-email",
        PHONE: "merchant-management-contact-information-phone",
        WEBSITE: "merchant-management-contact-information-website",
    },
    EMAIL: {
        INPUT: "merchant-management-email-input",
    },
};
